import Container from 'app/components/UI-Elements/Layout/Container'
import * as React from 'react'

import QuoteFeedbackEmpty from './Empty'

type Props = {
  quote: IQuote
  children: React.ReactNode
}

const QuoteFeedbackError: React.FC<Props> = ({ quote, children }) => {
  return (
    <Choose>
      <When condition={quote && quote.status === 'accepted'}>
        <Container>
          <QuoteFeedbackEmpty member={quote} props={{ messageType: 'accepted' }} />
        </Container>
      </When>
      <When condition={quote && !quote.valid}>
        <Container>
          <QuoteFeedbackEmpty member={quote} props={{ messageType: 'invalid' }} />
        </Container>
      </When>
      <Otherwise>{children}</Otherwise>
    </Choose>
  )
}

export default QuoteFeedbackError
